var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0133 7.80008L18.0933 3.22675C16.8 2.48008 15.2 2.48008 13.8933 3.22675L5.98664 7.80008C4.69331 8.54675 3.89331 9.93341 3.89331 11.4401V20.5601C3.89331 22.0534 4.69331 23.4401 5.98664 24.2001L13.9066 28.7734C15.2 29.5201 16.8 29.5201 18.1066 28.7734L26.0266 24.2001C27.32 23.4534 28.12 22.0667 28.12 20.5601V11.4401C28.1066 9.93341 27.3066 8.56008 26.0133 7.80008ZM16 9.78675C17.72 9.78675 19.1066 11.1734 19.1066 12.8934C19.1066 14.6134 17.72 16.0001 16 16.0001C14.28 16.0001 12.8933 14.6134 12.8933 12.8934C12.8933 11.1867 14.28 9.78675 16 9.78675ZM19.5733 22.2134H12.4266C11.3466 22.2134 10.72 21.0134 11.32 20.1201C12.2266 18.7734 13.9866 17.8667 16 17.8667C18.0133 17.8667 19.7733 18.7734 20.68 20.1201C21.28 21.0001 20.64 22.2134 19.5733 22.2134Z",
    fill: "#FC8019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.916509ca6ce6361917c3e4a87c613be3.svg";
export { ForwardRef as ReactComponent };